"use strict";
(() => {
	document.addEventListener("DOMContentLoaded", () => {
		quickSelectCollection();
	});

	document.addEventListener("filter:updated", () => {
		quickSelectCollection(); 
	});

	const quickSelectCollection = () => {
		/** ----------------------------------- **/
		/** ------------- GLOBALS --------------**/
		/** ----------------------------------- **/
		// default
		let collectionItemsInCartCount = 0;
		const cartWatchedCollection = document.querySelector("cart-drawer").dataset.watchedCollectionMixMatch;

		// product cheering bar
		const productCheeringBar = document.querySelector(".mix-and-match-bar");
		const productCheeringBarFill = document.querySelector(".mix-and-match-bar .product-cheering-bar__fill");
		const cartDrawer = document.querySelector(".cart-drawer");
		const watchedQuickSelectElement = document.querySelector('[data-quick-select="true"]');
		let veganBowlItemsLength;
		productCheeringBar?.addEventListener("click", () => {
			document.querySelector("#cart-icon-bubble").click();
		});
		// Quick selection collection template

		/** ------------------------------------------------------------------ **/
		/** function for quick select collection update in cart's cheering-bar **/
		/** ------------------------------------------------------------------ **/
		window.updateWatchingCollection = () => {
			const cartCheeringBarBowlsHint = document.querySelector(".Cart__cheering-bar__bowls");
 			const cartCheeringBarBowlsHintPercentage = document.querySelector(".Cart__cheering-bar__bowls span");
 			const drawerInner = document.querySelector(".cart-drawer .drawer__inner");
 			const cartItems = document.querySelectorAll(".cart-drawer .cart-item");

			// reset counter
			collectionItemsInCartCount = 0;

			// add counter value
			cartItems.forEach((cartItem) => {
				if (cartItem.dataset.quickSelectionItem === "true") {
					const selectedQuanitityOfWantedItem = parseInt(cartItem.querySelector(".quantity__input").value);
					collectionItemsInCartCount += selectedQuanitityOfWantedItem;
				}
			});
			if (collectionItemsInCartCount < 7) {
				cartCheeringBarBowlsHint.style.height = "0px";
				// drawerInner.style.paddingTop = "94px";
			} else if (collectionItemsInCartCount === 7) {
				cartCheeringBarBowlsHint.style.height = "42px";
				cartCheeringBarBowlsHint.style.display = "block";
				cartCheeringBarBowlsHintPercentage.textContent = "5%";
				// drawerInner.style.paddingTop = "136px";
			} else if (collectionItemsInCartCount > 7 && collectionItemsInCartCount < 15) {
				cartCheeringBarBowlsHint.style.height = "42px";
				cartCheeringBarBowlsHintPercentage.textContent = "5%";
				// drawerInner.style.paddingTop = "136px";
			} else if (collectionItemsInCartCount >= 15) {
				cartCheeringBarBowlsHint.style.height = "42px";
				cartCheeringBarBowlsHintPercentage.textContent = "15%";
				// drawerInner.style.paddingTop = "136px";
			} else {
				console.error("fatal error in bs-cart-drawer.js: unexpected integer given");
			}

			if (collectionItemsInCartCount < 7) {
				productCheeringBar.setAttribute("data-level", 1);
			} else if (collectionItemsInCartCount < 15) {
				productCheeringBar.setAttribute("data-level", 2);
			} else if (collectionItemsInCartCount >= 15) {
				productCheeringBar.setAttribute("data-level", 3);
			}

			if (productCheeringBar != undefined) {
				productCheeringBar.querySelectorAll(".product-cheering-bar__block").forEach((block, index) => {
					if (index < collectionItemsInCartCount) {
						block.style.setProperty('--block-background', '#125C46');
						block.style.setProperty('--block-text', '#fff');
					} else {
						block.style.setProperty('--block-background', '#e5e5e5');
						block.style.setProperty('--block-text', '#000');
					}
				});
			}
		};

		/** ----------------------------- **/
		/** Product cheering bar handling **/
		/** ----------------------------- **/
		const fakeUpdateProductCheeringBar = (command) => {
			if (productCheeringBar != undefined) {
				// use old value and add 1 to fake update product cheeringbar
				const widthPerItem = 100 / 15;

				switch (command) {
					case "plus":
						collectionItemsInCartCount += 1;
						break;
					case "minus":
						collectionItemsInCartCount -= 1;
						break;
					default:
						console.error("fatal error in mix-and-match-bar.js: unexpected command given");
				}

				// if (collectionItemsInCartCount < 7) {
				// 	productCheeringBar.dataset.level = 1;
				// 	productCheeringBarFill.style.width = widthPerItem * collectionItemsInCartCount + "%";
				// } else if (collectionItemsInCartCount === 7) {
				// 	productCheeringBar.dataset.level = 2;
				// 	productCheeringBarFill.style.width = "50%";
				// } else if (collectionItemsInCartCount > 7 && collectionItemsInCartCount < 15) {
				// 	productCheeringBar.dataset.level = 2;
				// 	productCheeringBarFill.style.width = widthPerItem * collectionItemsInCartCount + "%";
				// } else if (collectionItemsInCartCount >= 15) {
				// 	productCheeringBar.dataset.level = 3;
				// 	productCheeringBarFill.style.width = "100%";
				// } else {
				// 	console.error("fatal error in product-cheering-bar.js: unexpected integer given");
				// }
				
				if (collectionItemsInCartCount < 7) {
					productCheeringBar.setAttribute("data-level", 1);
				} else if (collectionItemsInCartCount < 15) {
					productCheeringBar.setAttribute("data-level", 2);
				} else if (collectionItemsInCartCount >= 15) {
					productCheeringBar.setAttribute("data-level", 3);
				}

				if (productCheeringBar != undefined) {
					productCheeringBar.querySelectorAll(".product-cheering-bar__block").forEach((block, index) => {
						if (index < collectionItemsInCartCount) {
							block.style.setProperty('--block-background', '#125C46');
							block.style.setProperty('--block-text', '#fff');
						} else {
							block.style.setProperty('--block-background', '#e5e5e5');
							block.style.setProperty('--block-text', '#000');
						}
					});
				}
			}
		};

		(() => {
			if (productCheeringBar != undefined) {
				const silentDcart = () => {
					// check if dcart error is shown and shut its mouth if its wrong
					const dcartCode = document.querySelector("#code");

					if (dcartCode != undefined) {
						if (dcartCode.value == "") {
							cartDrawer.classList.add("discountWrong");
							cartDrawer.classList.remove("Drawer__Footer__CouponActive");
						}
					} else {
						cartDrawer.classList.remove("discountWrong");
					}
				};

				document.addEventListener("DOMContentLoaded", () => {
					silentDcart();

					// when cart gets updated
					document.addEventListener("rerenderCart", () => {
						// iterate over cart items and look if they are contained in specified collection(data attribute), then update cheeringbar on collectionpage
						setTimeout(() => {
							silentDcart();
						}, 1000);
					});
				});

				// intersection observer for bar visibility
				const cheeringBarIntersectionObserver = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							productCheeringBar.classList.toggle("visible", entry.isIntersecting);
						});
					},
					{
						rootMargin: "-40%",
					},
				);

				cheeringBarIntersectionObserver.observe(watchedQuickSelectElement);
			}
		})();

		/** ----------------------------------- **/
		/** Quick selection collection template **/
		/** ----------------------------------- **/
		(() => {
			const cardProductsFromWatchedCollection = document.querySelectorAll('.product-grid .card-wrapper[data-collection="' + cartWatchedCollection + '"]');

			const productCheeringBarCalculator = (cart) => {
				const veganItems = cart.items.filter((item) => window.mixAndMatchProducts?.includes(item.variant_id));
				const infoStates = document.querySelector(".mix-and-match-bar__info-state");

				const veganMealsCounterFirstDiscount = document.querySelector(".mix-and-match-bar .meals-counter-first");
				const veganMealsCounterSecondDiscount = document.querySelector(".mix-and-match-bar .product-cheering-bar__hint .meals-counter-second");
				const addedInfoPrice = document.querySelector(".mix-and-match-bar .product-cheering-bar__info-products-added-state .product-cheering-bar__info-price");
				const compareAtPrice = document.querySelector(".mix-and-match-bar .product-cheering-bar__info-compare-at-price s");
				const discountedPrice = document.querySelector(".mix-and-match-bar .product-cheering-bar__info-discounted-price");

				const choosedMealsCounter = document.querySelector(".mix-and-match-bar .product-cheering-bar__choosed-meals .counter");

				let veganItemsTotalPrice = 0;
				let veganItemsTotalPriceFormatted;
				let veganItemsTotalDiscountedPrice = 0;
				let veganItemsTotalDiscountedPriceFormatted;

				let veganItemsTotalQuantity = 0;
				let stillLeftFirstDiscountCounter = 0;
				let stillLeftSecondDiscountCounter = 0;
				let veganItemsPrice = 0;
				let veganItemsDiscountedPrice = 0;

				veganItems.forEach((veganItem) => {
					veganItemsTotalPrice += veganItem.original_line_price;
					veganItemsTotalDiscountedPrice += veganItem.final_line_price;
					veganItemsTotalQuantity += veganItem.quantity;
				});

				// formatted prices
				veganItemsPrice = veganItemsTotalPrice / veganItemsTotalQuantity;
				veganItemsDiscountedPrice = veganItemsTotalDiscountedPrice / veganItemsTotalQuantity;
				veganItemsTotalPriceFormatted = Shopify.scFormatMoney(veganItemsPrice);
				veganItemsTotalDiscountedPriceFormatted = Shopify.scFormatMoney(veganItemsDiscountedPrice);

				stillLeftFirstDiscountCounter = Math.max(1, 7 - veganItemsTotalQuantity);
				stillLeftSecondDiscountCounter = Math.max(1, 15 - veganItemsTotalQuantity);

				if ( veganItemsTotalDiscountedPriceFormatted !== veganItemsTotalPriceFormatted) {
					infoStates.classList.add("active");
				} else {
					infoStates.classList.remove("active");
				}

				if(veganItemsDiscountedPrice > 0) {
					discountedPrice.textContent = veganItemsTotalDiscountedPriceFormatted;
				} else {
					discountedPrice.textContent = Shopify.scFormatMoney(document.querySelector('[data-price]').dataset.price);
				}
				compareAtPrice.textContent = veganItemsTotalPriceFormatted;

				//choosed meal counter
				if (veganItemsTotalQuantity === 1) {
					choosedMealsCounter.innerHTML = veganItemsTotalQuantity + " Meal ";
				} else {
					choosedMealsCounter.innerHTML = veganItemsTotalQuantity + " Meals ";
				}

				// show initial state
				if (veganItemsTotalQuantity === 6) {
					veganMealsCounterFirstDiscount.innerHTML = stillLeftFirstDiscountCounter + " Meal";
				} else {
					veganMealsCounterFirstDiscount.innerHTML = stillLeftFirstDiscountCounter + " Meals";
				}
				
				if (veganItemsTotalQuantity > 0) {
					document.querySelector(".column-bottom rect").style.display = "block";
				} else {
					document.querySelector(".column-bottom rect").style.display = "none";
				}
			};

			// function to update quick select cards with cart item quantities
			const mapCartQuantitiesWithQuickSelects = () => {
				// Wait for DOM to be fully updated before proceeding
				requestAnimationFrame(() => {
					const cartItemsFromWatchedCollection = document.querySelectorAll('.cart-items .cart-item[data-quick-selection-item="true"]');

					cartItemsFromWatchedCollection.forEach((cartItem) => {
						cardProductsFromWatchedCollection.forEach((card) => {
							if (cartItem.dataset.variantId === card.dataset.variantId) {
								const cartItemQuantityInput = cartItem.querySelector(".quantity__input");
								const cardQuickSelect = card.querySelector(".card__quick-select");
								const cardQuickSelectInput = card.querySelector(".card__quick-select input");

								if (cartItemQuantityInput && cardQuickSelect && cardQuickSelectInput) {
									cardQuickSelect.classList.add("active");
									cardQuickSelectInput.value = cartItemQuantityInput.value;
								}
							}
						});
					});

					// Add delay to ensure cart update has been processed by Shopify
					setTimeout(() => {
						fetch("/cart.json")
							.then((response) => response.json())
							.then((cart) => {
								const veganItems = cart.items.filter((item) => window.mixAndMatchProducts.includes(item.variant_id));
								veganBowlItemsLength = veganItems.length;
								if (productCheeringBar !== null) {
									productCheeringBarCalculator(cart);
								}
							})
							.catch((error) => {
								console.error('Error fetching cart:', error);
							});
					}, 300); // Wait 300ms for Shopify to process the cart update
				});
			};

			// Enhanced initial call with better timing
			const initializeMapping = () => {
				// Use multiple strategies to ensure DOM is ready
				if (document.readyState === 'loading') {
					document.addEventListener('DOMContentLoaded', mapCartQuantitiesWithQuickSelects);
				} else {
					// DOM is already loaded, but wait a frame to ensure all updates are complete
					requestAnimationFrame(mapCartQuantitiesWithQuickSelects);
				}
			};

			initializeMapping();

			// Enhanced event listener with debouncing
			let rerenderTimeout;
			document.addEventListener("rerenderCart", () => {
				// Clear any pending rerender calls to avoid rapid successive calls
				clearTimeout(rerenderTimeout);
				rerenderTimeout = setTimeout(() => {
					mapCartQuantitiesWithQuickSelects();
				}, 150); // Slightly longer delay to ensure DOM updates are complete
			});

			// quick select on each card
			cardProductsFromWatchedCollection.forEach((card) => {
				const quantitySelector = card.querySelector(".card__quick-select");
				const firstPlusButton = card.querySelector(".card__quick-select--add");
				const input = card.querySelector("input");
				const plusButton = card.querySelector(".card__quick-select__plus");
				const minusButton = card.querySelector(".card__quick-select__minus");

				firstPlusButton.addEventListener("click", () => {
					quantitySelector.classList.add("active");
					input.value = 1;
					input.dispatchEvent(new Event("change"));
					fakeUpdateProductCheeringBar("plus");
				});

				plusButton.addEventListener("click", () => {
					quantitySelector?.classList.add("loading");
					fakeUpdateProductCheeringBar("plus");

					setTimeout(() => {
						input.value = parseInt(input.value) + 1;
						input.dispatchEvent(new Event("change"));
					}, 100);

					setTimeout(() => { 
						quantitySelector.classList.remove("loading");
					}, 750);
				});

				minusButton.addEventListener("click", () => {
					quantitySelector.classList.add("loading");
					fakeUpdateProductCheeringBar("minus");

					setTimeout(() => {
						input.value = parseInt(input.value) - 1;
						input.dispatchEvent(new Event("change"));
						if (input.value == 0) {
							quantitySelector.classList.remove("active");
						}
					}, 100);

					setTimeout(() => {
						quantitySelector.classList.remove("loading");

						if (input.value == 0) {
							quantitySelector.classList.remove("active");
						}
					}, 750);
				});

				input.addEventListener("change", () => {
					const inputtedCard = input.closest(".card-wrapper__quick-select");
					const depositVariantId = input.dataset.depositId;
					const depositAmount = Number(input.dataset.depositAmount) * Number(input.value);
					let cartUpdates;

					try {
						if (depositAmount) {
							cartUpdates = {
								updates: {
									[depositVariantId]: depositAmount,
									[inputtedCard.dataset.variantId]: input.value,
								},
							};
						} else {
							cartUpdates = {
								updates: {
									[inputtedCard.dataset.variantId]: input.value,
								},
							};
						}

						fetch(window.Shopify.routes.root + "cart/update.js", {
							method: "POST",
							headers: {
								"Content-Type": "application/json",
							},
							body: JSON.stringify(cartUpdates),
						})
							.then((response) => response.json())
							.then((response) => {
								fetch(window.location.href)
									.then((response) => response.text())
									.then((responseText) => {
										const oldItemsWrapper = document.querySelector(".drawer__inner");
										const html = new DOMParser().parseFromString(responseText, "text/html");
										const newItemsWrapper = html.querySelector(".drawer__inner");
										const cartDrawer = document.querySelector("cart-drawer");
										const oldIconCart = document.querySelector("#cart-icon-bubble");
										const newIconCart = html.querySelector("#cart-icon-bubble");
										const oldCartHeader = document.querySelector('.drawer__header');
										const newCartHeader = html.querySelector('.drawer__header');
										const oldCartFooter = document.querySelector('.drawer__footer');
										const newCartFooter = html.querySelector('.drawer__footer');


										oldIconCart.innerHTML = newIconCart.innerHTML;
										oldItemsWrapper.innerHTML = newItemsWrapper.innerHTML;
										oldCartHeader.innerHTML = newCartHeader.innerHTML;
										oldCartFooter.innerHTML = newCartFooter.innerHTML;

										if (response.item__count == 0) {
											cartDrawer.classList.add("is-empty");
										} else {
											cartDrawer.classList.remove("is-empty");
										}

										// else update cart
										setTimeout(() => {
											document.dispatchEvent(new CustomEvent("rerenderCart"));
										}, 100);
									})
									.catch((e) => {
										console.error(e);
									});
							});
					} catch (error) {
						return false;
					}
				});
			});

			// function for: if cart item gets removed completely -> update associated quick select card
			window.removeQuickSelectEntry = (variantId) => {
				const cardProductsFromWatchedCollection = document.querySelectorAll('.product-grid .card-wrapper[data-collection="' + cartWatchedCollection + '"]');

				cardProductsFromWatchedCollection.forEach((cardItem) => {
					if (cardItem.dataset.variantId == variantId) {
						setTimeout(() => {
							const input = cardItem.querySelector("input");
							const quantitySelector = cardItem.querySelector(".card__quick-select");

							input.value = 0;
							quantitySelector.classList.remove("active");
						}, 1000);
					}
				});
			};
		})();
	};
})();

localStorage.setItem('showBackLink', 'true');
